// angular
// 	.module("HeroPRO")
// 	.controller("TrainingQAndAController", testController);

import angular from 'angular';

import './trainingQAndA.scss';

/* @ngInject */
export default function testController($scope, $rootScope, $document) {
    $scope.qAnda.select = function (answer) {
        $rootScope.$broadcast('answerSelected', { selection: answer });
        if ($scope.qAnda.current) $scope.qAnda.current.SelectedAnswer = answer;
        angular.element($document[0].querySelectorAll(`.${$scope.qAnda.parentClass} .icon-radio-default`)).removeClass('no-selection');
    };
}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/training/directives/trainingQA/trainingQAndAController.js